/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-05-06 16:26:09
 * @LastEditors: luckymiaow
 */
import type { TreeProps } from 'ant-design-vue';
import type { EventDataNode } from 'ant-design-vue/lib/tree';
import type { FieldNames } from 'ant-design-vue/lib/vc-tree/interface';
export const virtualKey = Symbol('addKey').toString();

export type InjectBaseTreeConfig = BaseTree;

export interface BaseTree extends TreeProps {
  options?: IBaseTreeOptions<unknown>;
  loadData?(node: { dataRef: TreeNodeSlotsNode<unknown> } | EventDataNode): Promise<void>;
  treeData?: TreeNode<unknown>[];
  expandedKeys?: string[] | number[];
  ellipsis?: boolean; // 省略标题
  fieldNames?: FieldNames;
}

/**
 * @description: 外部使用的参数接口
 * @param {*}
 * @return {*}
 * @author: luckymiaow
 */
export interface ITreeTool<T> {
  addTreeNode(item?: { dataRef: TreeNode<T> }): void; // 添加节点，参数为空时添加一级节点
  treeData?: TreeNode<unknown>[];
}

export enum OperatingType {
  del,
  rename,
  add,
}

export class TreeNode<T> {
  key: string = virtualKey;
  value: string | null = ''; // title全路径
  title?: string | null = '';
  childCount?: number = 0;
  children?: TreeNode<T>[] = [];
  data?: T | null = null;
}

export interface IBaseTreeOptions<T> {
  canAddChild?: boolean; // 是否可以添加节点

  canRename?: boolean; // 是否可以重命名节点

  canDelete?: boolean; // 是否可以删除节点

  canMove?: boolean; // 是否可以移动节点

  addChildAsync?: (directory: string, name: string, parentNode: TreeNode<T> | null) => Promise<TreeNode<T>>;

  renameAsync?: (node: TreeNode<T>, newName: string) => Promise<any>;

  deleteAsync?: (node: TreeNode<T>) => Promise<void>;

  moveAsync?: (node: TreeNode<T>, newNode: TreeNode<T>) => Promise<void>;

  SortMoveBefore?: (id: string, idRefer: string) => Promise<void>;

  findChild?: (node: TreeNode<T>, depth: number) => Promise<TreeNode<T>[]>;
}
export class TreeNodeSlotsNode<T> implements TreeNode<T> {
  get key() {
    return this.node.key;
  }

  set key(val: string) {
    this.node.key = val;
  }

  get title() {
    return this.node.title as string;
  }

  set title(val: string) {
    this.node.title = val;
  }

  get value() {
    return this.node.value;
  }

  set value(val: string) {
    this.node.value = val;
  }

  get childCount() {
    return this.node.childCount as number;
  }

  set childCount(val: number) {
    this.node.childCount = val;
    this.isLeaf = val == 0;
  }

  get children() {
    return this.node.children as TreeNodeSlotsNode<T>[];
  }

  set children(val: TreeNodeSlotsNode<T>[]) {
    this.node.children = val;
  }

  get data() {
    return this.node.data;
  }

  set data(val: any) {
    this.node.data = val;
  }

  on = false;

  isEdit = true;

  // 节点是否可编辑
  disabled = false;

  // 节点编辑按钮
  editBtn = true;

  // 节点添加按钮
  addBtn = true;

  // 节点删除按钮
  delBtn = true;

  // 存在子节点
  isLeaf = true;

  node: TreeNode<T>;

  parent: TreeNodeSlotsNode<T>;

  public constructor(node: TreeNode<T> | null, parent: TreeNodeSlotsNode<T> | null) {
    this.node = node || {
      key: virtualKey,
      title: null,
      value: null,
      childCount: 0,
      children: [],
    };
    if (!this.node.children) this.node.children = [];
    if (this.node.children?.length > 0) this.node.childCount = this.node.children.length;
    this.isLeaf = (this.node?.childCount ?? 0) == 0;
    this.parent = parent!;
  }
}
